import { QuickTable, QuickTableFilterTabs } from "../../components";
// import { PayoutForm } from "./PayoutForm";
import { payoutsDisplayFormatter } from "./payoutsDisplayFormatter";
import { IPayoutViewProps } from "./Payouts";

export const View = (props: IPayoutViewProps) => {
  return (
    <>
      <QuickTable
        id="payoutsTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        renderDetail={(item) => item.account_number}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={payoutsDisplayFormatter}
        onExport={props.onExport}
        // openCreateNewModal={props.openCreateNewModal}
        createNewButtonText="New Payout"
      />

      {/* <PayoutForm
        refreshTable={props.refreshTable}
        isModalOpen={props.isCreateNewModalOpen}
        closeModal={props.closeModal}
      /> */}
    </>
  );
};
